import {Component, inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {SiteMessage} from "../../models/site-message";
import {RepoService} from "../../services/repo.service";

@Component({
  selector: 'app-delete-site-message-dialog',
  imports: [],
  templateUrl: './delete-site-message-dialog.component.html',
  styleUrl: './delete-site-message-dialog.component.css'
})
export class DeleteSiteMessageDialogComponent {

  dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  siteMessage: SiteMessage = inject(DIALOG_DATA);

  repoService = inject(RepoService)

  async deleteClicked() {
    await this.repoService.deleteSiteMessage(this.siteMessage)
    this.dialogRef.close();
  }
}
